export const russianMessages = {
  ra: {
    core: {
      validation: {
        required: "Обязательное поле",
        minLength: "Минимум %{min} символов",
        maxLength: "Максимум %{max} символов",
        minValue: "Минимум %{min}",
        maxValue: "Максимум %{max}",
        number: "Должно быть числом",
        email: "Должен быть корректный email",
        oneOf: "Должно быть одно из: %{options}",
        regex: "Должно соответствовать формату (regexp): %{pattern}",
      },
    },
    action: {
      delete: "Удалить",
      show: "Показать",
      list: "Список",
      save: "Сохранить",
      create: "Создать",
      edit: "Редактировать",
      sort: "Сортировать",
      cancel: "Отмена",
      undo: "Отменить",
      refresh: "Обновить",
      add: "Добавить",
      remove: "Удалить",
      add_filter: "Добавить фильтр",
      remove_filter: "Удалить этот фильтр",
      back: "Назад",
      bulk_actions: "Выбран 1 элемент |||| Выбрано %{smart_count} элементов",
      export: "Экспорт",
      unselect: "Снять выделение",
      expand: "Развернуть",
      close: "Закрыть",
      open_menu: "Открыть меню",
      close_menu: "Закрыть меню",
    },
    boolean: {
      true: "Да",
      false: "Нет",
      null: " ",
    },
    page: {
      create: "Создать %{name}",
      dashboard: "Дашборд",
      edit: "%{name} #%{id}",
      error: "Что-то пошло не так",
      list: "%{name}",
      loading: "Загрузка",
      not_found: "Не найдено",
      show: "%{name} #%{id}",
      empty: "Нет %{name} пока",
      invite: "Хотите добавить один?",
    },
    input: {
      file: {
        upload_several:
          "Перетащите файлы для загрузки, или нажмите для выбора.",
        upload_single: "Перетащите файл для загрузки, или нажмите для выбора.",
      },
      image: {
        upload_several:
          "Перетащите изображения для загрузки, или нажмите для выбора.",
        upload_single:
          "Перетащите изображение для загрузки, или нажмите для выбора.",
      },
      references: {
        all_missing: "Невозможно найти ссылочные данные.",
        many_missing:
          "По крайней мере одна из связанных ссылок больше недоступна.",
        single_missing: "Связанная ссылка больше недоступна.",
      },
      password: {
        toggle_visible: "Скрыть пароль",
        toggle_hidden: "Показать пароль",
      },
    },
    message: {
      yes: "Да",
      no: "Нет",
      are_you_sure: "Вы уверены?",
      about: "О программе",
      not_found:
        "Либо вы ввели неправильный URL, либо перешли по неправильной ссылке.",
      loading: "Страница загружается, подождите немного",
      invalid_form: "Форма заполнена неправильно. Пожалуйста, проверьте ошибки",
      delete_title: "Удалить %{name} #%{id}",
      delete_content: "Вы действительно хотите удалить этот элемент?",
      bulk_delete_title: "Удалить %{name} |||| Удалить %{smart_count} %{name}",
      bulk_delete_content:
        "Вы действительно хотите удалить этот %{name}? |||| Вы действительно хотите удалить эти %{smart_count} элемента?",
    },
    navigation: {
      no_results: "Результаты не найдены",
      no_more_results:
        "Страница %{page} выходит за границы. Попробуйте предыдущую страницу.",
      page_out_of_boundaries: "Страница %{page} выходит за границы",
      page_out_from_end: "Нельзя перейти после последней страницы",
      page_out_from_begin: "Нельзя перейти до страницы 1",
      page_range_info: "%{offsetBegin}-%{offsetEnd} из %{total}",
      page_rows_per_page: "Строк на странице:",
      next: "Следующая",
      prev: "Предыдущая",
      first: "Первая",
      last: "Последняя",
    },
    auth: {
      user_menu: "Профиль",
      username: "Имя пользователя",
      password: "Пароль",
      sign_in: "Войти",
      sign_in_error: "Ошибка аутентификации, попробуйте снова",
      logout: "Выйти",
    },
    notification: {
      updated: "Элемент обновлен |||| %{smart_count} элементов обновлено",
      created: "Элемент создан",
      deleted: "Элемент удален |||| %{smart_count} элементов удалено",
      bad_item: "Неправильный элемент",
      item_doesnt_exist: "Элемент не существует",
      http_error: "Ошибка сервера",
      data_provider_error:
        "Ошибка dataProvider. Проверьте консоль для деталей.",
      i18n_error: "Невозможно загрузить переводы для указанного языка",
      canceled: "Действие отменено",
      logged_out: "Ваша сессия завершена, пожалуйста, переподключитесь.",
    },
  },
  resources: {
    users: {
      name: "Пользователь |||| Пользователи",
      fields: {
        id: "ID",
        name: "Имя",
        email: "Email",
        phone: "Телефон",
        profession: "Профессия",
        location: "Местоположение",
        avatarUrl: "Аватар",
        isVerified: "Верифицирован",
        twoFactorEnabled: "2FA включен",
        followersCount: "Подписчики",
        followingCount: "Подписки",
        createdAt: "Создан",
        updatedAt: "Обновлен",
      },
      tabs: {
        general: "Основная информация",
        security: "Безопасность",
        social: "Социальные связи",
        challenges: "Челленджи",
        orders: "Заказы",
      },
      social: {
        followers: "Подписчики",
        following: "Подписки",
        no_followers: "Нет подписчиков",
        no_following: "Нет подписок",
        loading_followers: "Загрузка подписчиков...",
        loading_following: "Загрузка подписок...",
        error: "Ошибка",
      },
      challenges: {
        created_challenges: "Созданные челленджи",
        no_challenges: "Нет созданных челленджей",
        loading: "Загрузка челленджей...",
        type: "Тип",
        status: "Статус",
        mode: "Режим",
        participants: "Участников",
        current_streak: "Текущая серия",
        best_streak: "Лучшая серия",
        created: "Создан",
        start: "Начало",
        end: "Конец",
        group: "Групповой",
        personal: "Личный",
      },
      orders: {
        supplement_orders: "Заказы добавок",
        no_orders: "Нет заказов",
        loading: "Загрузка заказов...",
        order_id: "ID заказа",
        quantity: "Количество",
        status: "Статус",
        payment: "Оплата",
        paid: "Оплачен",
        not_paid: "Не оплачен",
        context: "Контекст",
        recommendation_reason: "Причина рекомендации",
        created: "Создан",
        paid_at: "Оплачен",
      },
    },
    challenges: {
      name: "Челлендж |||| Челленджи",
      fields: {
        id: "ID",
        title: "Название",
        description: "Описание",
        type: "Тип",
        status: "Статус",
        mode: "Режим",
        author: "Автор",
        participants: "Участники",
        createdAt: "Создан",
        updatedAt: "Обновлен",
      },
    },
    supplements: {
      name: "Добавка |||| Добавки",
      fields: {
        id: "ID",
        name: "Название",
        description: "Описание",
        price: "Цена",
        emoji: "Эмодзи",
        benefits: "Преимущества",
        duration: "Длительность",
      },
    },
    supplementOrders: {
      name: "Заказ |||| Заказы",
      fields: {
        id: "ID заказа",
        client: "Клиент",
        supplement: "Добавка",
        quantity: "Количество",
        totalPrice: "Сумма",
        status: "Статус",
        isPaid: "Оплачен",
        createdAt: "Создан",
        paidAt: "Оплачен",
      },
    },
    paymentTransactions: {
      name: "Платеж |||| Платежи",
      fields: {
        id: "ID",
        client: "Клиент",
        order: "Заказ",
        amount: "Сумма",
        currency: "Валюта",
        status: "Статус",
        method: "Способ",
        provider: "Провайдер",
        createdAt: "Создан",
      },
    },
    challengeUpdates: {
      name: "Событие |||| События челленджей",
      fields: {
        id: "ID",
        type: "Тип",
        content: "Содержимое",
        user: "Пользователь",
        challenge: "Челлендж",
        dayNumber: "День",
        createdAt: "Создано",
      },
    },
    chatMessages: {
      name: "Сообщение |||| Чат-сообщения",
      fields: {
        id: "ID",
        role: "Роль",
        content: "Содержимое",
        user: "Пользователь",
        createdAt: "Создано",
      },
    },
    notifications: {
      name: "Уведомление |||| Уведомления",
      fields: {
        id: "ID",
        type: "Тип",
        channel: "Канал",
        status: "Статус",
        title: "Заголовок",
        content: "Содержание",
        recipient: "Получатель",
        templateName: "Шаблон",
        errorMessage: "Сообщение об ошибке",
        retryCount: "Количество попыток",
        sentAt: "Отправлено",
        userId: "ID пользователя",
        user: "Пользователь",
        createdAt: "Создано",
        updatedAt: "Обновлено",
      },
    },
    notificationQueue: {
      name: "Очередь уведомлений",
    },
    notificationStats: {
      name: "Статистика уведомлений",
    },
  },
  dashboard: {
    title: "Дашборд",
    stats: {
      total_users: "Всего пользователей",
      total_challenges: "Всего челленджей",
      total_orders: "Всего заказов",
      total_activities: "Всего активностей",
      activities_subtitle: "Чекины, изменения статуса",
    },
    charts: {
      user_registration: "Регистрация пользователей",
      challenge_types: "Типы челленджей",
      order_statuses: "Статусы заказов",
      activity_types: "Типы активностей",
      daily_activity: "Активность по дням (30 дней)",
    },
  },
  challengeTypes: {
    QUIT_SMOKING: "Бросить курить",
    QUIT_PORN: "Бросить порно",
    QUIT_SUGAR: "Бросить сахар",
    QUIT_ALCOHOL: "Бросить алкоголь",
    EXERCISE: "Упражнения",
    MEDITATION: "Медитация",
    READING: "Чтение",
    WATER_DRINKING: "Пить воду",
    SLEEP_SCHEDULE: "Режим сна",
    NO_SOCIAL_MEDIA: "Без соцсетей",
    CUSTOM: "Кастомный",
  },
  challengeStatuses: {
    ACTIVE: "Активный",
    PAUSED: "Приостановлен",
    COMPLETED: "Завершен",
    FAILED: "Провален",
  },
  orderStatuses: {
    PENDING: "Ожидает",
    PROCESSING: "Обрабатывается",
    SHIPPED: "Отправлен",
    DELIVERED: "Доставлен",
    CANCELLED: "Отменен",
  },
  challengeActivityTypes: {
    START: "Начало челленджа",
    CHECKIN: "Чекин",
    STATUS_CHANGE: "Изменение статуса",
    COMMENT: "Комментарий",
    LIKE: "Лайк",
    COMPLETE: "Завершение",
    FAIL: "Провал",
  },
};
